//!#system	

<template>
	<v-card>
		<v-form ref="passwordChangeForm" v-model="validPasswordForm" lazy-validation>
			<v-card-title>
				<span class="headline">Change password</span>
			</v-card-title>
			<v-card-text>
					<v-text-field 
						v-model="passwordChange.currentPassword" 
						label="Current password" 
						type="password"
						required
						password
						autocomplete="current-password"
					></v-text-field>
					<v-text-field 
						v-model="passwordChange.newPasswordOne" 
						label="New password" 
						:rules="passwordRules"
						type="password"
						required
						password
						autocomplete="new-password"
					></v-text-field>
					<v-text-field 
						v-model="passwordChange.newPasswordConfirm" 
						label="Confirm password" 
						:rules="passwordMatchRules"
						type="password"
						required
						password
						autocomplete="new-password"
					></v-text-field>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="primary" :disabled="!validPasswordForm" :loading="doingFormSubmission" @click="submitPasswordChangeRequest">Save</v-btn>
			</v-card-actions>
		</v-form>
	</v-card>
</template>

<script>
import apiService from '@/apiService';
export default {
	name: 'UserPasswordReset',
	data() {
		return {
			doingFormSubmission: false,
			passwordChange: {
				currentPassword: '',
				newPasswordOne: '',
				newPasswordConfirm: ''
			},
			passwordRules: [
				v => !!v || 'Password is required',
				v => {
					return v.length < 6 ? 'Password must be greater than 6 characters' : true
				},
				v => {
					// eslint-disable-next-line
					const passwordTest = zxcvbn(v);
					let err = 'Your password needs to be stronger than that.';
					if (passwordTest.feedback && passwordTest.feedback.warning) {
						err = passwordTest.feedback.warning;
					}
					return passwordTest.score <= 2 ? err : true;
				}
			],
			passwordMatchRules: [
				v => this.passwordChange.newPasswordOne !== this.passwordChange.newPasswordConfirm ? 'Make sure your passwords match.' : true
			],
			validPasswordForm: false
		}
	},
	methods: {
		submitPasswordChangeRequest() {
			this.doingFormSubmission = true;
			apiService.call({
				path: '/_sys/internals/uac/self-password-reset',
				method: 'POST',
				params: {
					currentPassword: this.passwordChange.currentPassword,
					newPasswordOne: this.passwordChange.newPasswordOne,
					newPasswordConfirm: this.passwordChange.newPasswordConfirm
				}
			}, (err, response, meta) => {
				this.doingFormSubmission = false;
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: meta.validation ? meta.validation.messages.join('\n') : err 
					});
				} else {
					this.$emit('saved');
					this.$store.dispatch('app/applyObjectUpdated', {
						show: true,
						text: 'Your password has been updated.'
					});
				}
			});
		}
	}
}
</script>